import React from 'react'
import TalentDensityFeature from '../Components/TalentDensityFeature'
import EliteNetworkDashboard from '../Components/EliteNetworkDashboard'
import TalentIntelligenceEngine from '../Components/TalentIntelligenceEngine'

function TalentDensityFeaturePage() {
  return (
    <div>

<TalentIntelligenceEngine/>        
        <TalentDensityFeature/>
        <EliteNetworkDashboard/>

    </div>
  )
}

export default TalentDensityFeaturePage